export const REVIEW_HISTORY_ACTIONS = {
	SEND_BACK_TO_ADDRESS_COMMENTS: 'SendBackToAddressComments',
} as const;

export type ReviewHistoryAction = (typeof REVIEW_HISTORY_ACTIONS)[keyof typeof REVIEW_HISTORY_ACTIONS];
